import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PrivateHeader from '../components/header/private-header.component'
import { Suspense } from 'react'
import Loading from '../components/loading/loading.component'
import RenewSubscription from 'screens/renew-subscription/renew-screen'
import PublicHeader from '../components/header/public-header.component'
import Chat from 'components/chat/chat.component'
import BadgePopup from 'screens/careers/modalContent/CelebrationModal'
import { useLayout } from '../contexts/LayoutContext'

const ProtectedRoutes = () => {
  const { userInfo } = useSelector((state: any) => state.auth)
  const { isChatOpen, isSidebarCollapsed } = useLayout()
  const { pathname } = useLocation()

  // Helper function to get main content classes based on layout state
  const hideTopBar = pathname === '/home'
  const getMainContentClasses = () => {
    const tightRoutes = ['/user-careers', '/home']
    const isTight = tightRoutes.includes(pathname)
    const padding = isTight ? 'p-3 sm:px-8 sm:py-5' : 'p-4 sm:p-8'
    const heightClass = hideTopBar ? 'h-screen' : 'h-[calc(100vh-86px)]'
    const baseClasses = `${heightClass} overflow-y-auto transition-all duration-300 ease-in-out ${padding}`
    
    if (isChatOpen) {
      // When chat is open, content should fit between collapsed sidebar (64px) and chat (404px)
      return `${baseClasses} ml-[72px] mr-0 sm:ml-[72px] sm:mr-[404px]`
    } else {
      // Normal layout - account for sidebar width only
      if (isSidebarCollapsed) {
        return `${baseClasses} ml-[72px] mr-0 sm:ml-[72px] sm:mr-0`
      } else {
        return `${baseClasses} ml-[280px] mr-0 sm:ml-[280px] sm:mr-0`
      }
    }
  }
  return (
    <>
      {!userInfo ? (
        <Navigate to="/login" replace />
      ) : (
        <>
          {userInfo.user.role === 'super' ||
          userInfo.user.role === 'partner' ||
          (userInfo.user.is_account_activated &&
            userInfo.user.profile?.onboarding_completed) ? (
            <>
              <PrivateHeader userInfo={userInfo.user} key={userInfo.user.id} />
              {process.env.REACT_APP_ENABLE_CHAT && <Chat />}
              
              <div
                className={getMainContentClasses()}
                style={{
                  height: hideTopBar
                    ? '100vh'
                    : window.innerWidth >= 500
                      ? 'calc(100vh - 86px)'
                      : 'calc(100vh - 150px)',
                }}
              >
                <Suspense fallback={<Loading />}>
                  <BadgePopup />
                  <Outlet />
                </Suspense>
              </div>
            </>
          ) : (
            <>
              {userInfo.user.role === 'user' && (
                <>
                  {/* For User gifted */}
                  {userInfo.user.subscription.gift_by !== null &&
                    !userInfo.user.profile?.onboarding_completed && (
                      <Navigate to={userInfo.user.profile?.welcome_video_watched ? "/on-boarding/start" : "/on-boarding"} replace />
                    )}
                  {/* For User who have not paid yet */}
                  {userInfo.user.has_subscription_expired === false &&
                    userInfo.user.is_account_activated === false && (
                      <>
                        <PublicHeader showLogout />
                        <RenewSubscription dialogue={false} />
                      </>
                    )}

                  {/* For Existing User whose payment should be renewed */}
                  {userInfo.user.has_subscription_expired === true &&
                    userInfo.user.is_account_activated === false && (
                      <>
                        <PublicHeader showLogout />
                        <RenewSubscription dialogue={true} />
                      </>
                    )}

                  {userInfo.user.is_account_activated &&
                    !userInfo.user.profile?.onboarding_completed && (
                      <Navigate to={userInfo.user.profile?.welcome_video_watched ? "/on-boarding/start" : "/on-boarding"} replace />
                    )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export default ProtectedRoutes
